import React from 'react';

import { IconTooltip } from '../../IconTooltip';
import DiagramChart from './DiagramComponent/DiagramChart';
import LegendForChart from './DiagramComponent/LegendForChart';
import LoadingView from './DiagramComponent/LoadingView/LoadingView';
import { StyledContent, StyledEmptyView, StyledTitle, StyledWrapper, StyledWrapperTitle } from './styled';

export type ChartsData = {
  name: string;
  value: number;
  color: string;
};

type Props = {
  title: string;
  tooltip: string;
  data?: ChartsData[] | null;
  loading?: boolean;
  emptyText: string;
  metricName?: string;
};

const DiagramComponent = ({ title, tooltip, data, loading, emptyText, metricName }: Props): JSX.Element => {
  const total = data?.length ? data.reduce((acc, cur) => acc + cur.value, 0) : 0;

  if (loading) {
    return <LoadingView title={title} tooltip={tooltip} />;
  }

  return (
    <StyledWrapper data-testid="chartWrapper">
      <StyledWrapperTitle>
        <StyledTitle>{title}</StyledTitle>
        <div>
          <IconTooltip description={tooltip} blackTheme />
        </div>
      </StyledWrapperTitle>
      {data?.length ? (
        <StyledContent data-testid="pieChartWrapper">
          <DiagramChart metricName={metricName} data={data} total={total} title={title} />
          <LegendForChart data={data} total={total} />
        </StyledContent>
      ) : (
        <StyledEmptyView>{emptyText}</StyledEmptyView>
      )}
    </StyledWrapper>
  );
};
export default DiagramComponent;
